import { Card } from '@components/primitives/Card.js'
import { Button } from '@components/primitives/Button.js'

interface Props {
  onLimpar: () => void
}

export function ZonaPerigoSection({ onLimpar }: Props) {
  return (
    <Card surface='raised' className='cf3-config-danger-card'>
      <div className='cf3-config-section'>
        <p className='cf3-config-section__title cf3-config-section__title--danger'>
          Zona de Perigo
        </p>
        <p className='cf3-config-section__desc'>
          Apaga permanentemente todos os dados do aplicativo: obra, progresso, lançamentos,
          documentos e diário. Esta ação <strong>não pode ser desfeita</strong>.
        </p>
        <Button variant='danger' size='sm' onClick={onLimpar}>
          Limpar todos os dados
        </Button>
      </div>
    </Card>
  )
}
